import BaseApi from "./BaseApi";

export function joinPresence(data) {
  return BaseApi.post("/diaries/presence/join", data);
}

export function heartbeatPresence(data) {
  return BaseApi.post("/diaries/presence/heartbeat", data);
}

export function leavePresence(data) {
  return BaseApi.post("/diaries/presence/leave", data);
}

export function getActiveEditors(params) {
  return BaseApi.get("/diaries/presence", { params });
}
